import api from "@/utils/http";

/**
 功能：查看指定客户账单
 time: 2025/12/16 11:02
 **/
export function getCustomerBillList(customer_id) {
    return api.post('/admin/income/getCustomerBillList', { customer_id})
}

/**
 功能：
 time: 2026/1/6 16:19
 **/
export function getIncomeList(data) {
    return api.post('/partner/income/getList', data)
}

/**
 功能：
 time: 2026/3/9 15:16
 **/
export function getIncomeStatic(data) {
    return api.post('/partner/income/getStaticData', data)
}

/**
 功能：
 time: 2026/1/6 18:43
 **/
export function getIncomeSelectList(data) {
    return api.post('/admin/income/getSearchList',data)
}
/**
 功能：项目收款
 time: 2025/12/25 16:02
 **/
export function saveIncome(data) {
    return api.post('/admin/income/eSave', data)
}

/**
 功能：
 time: 2025/12/25 16:31
 **/
export function getIncomeConfig() {
    return api.get('/admin/income/getSetConfig')
}

/**
 功能：
 time: 2025/12/25 18:19
 **/
export function getIncomeDetail(id) {
    return api.post('/partner/income/getDetail', {id })
}

/**
 功能：
 time: 2025/12/26 10:34
 **/
export function deleteIncome(id) {
    return api.post('/admin/income/del', {id})
}

/**
 功能：
 time: 2025/12/26 14:25
 **/
export function examineIncome(data) {
    return api.post('/admin/income/examineSave', data)
}

/**
 功能：
 time: 2026/1/7 09:19
 **/
export function getIncomeInvoice(id) {
    return api.post('/admin/income/getInvoiceInfo', { id })
}
